import '../../lib/bootstrap.scss';
import '../../lib/main.scss';

import Head from 'next/head';
import { Component } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import { hotjar } from '../../utils/services/hotjar';

export default class Layout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileNavOpen: false,
    };

    this.onMobileNavToggle = this.onMobileNavToggle.bind(this);
  }

  componentDidMount() {
    hotjar.initialize(1660732, 6);
  }

  onMobileNavToggle(state) {
    this.setState({ mobileNavOpen: state });
  }

  render() {
    return (
      <div className={`layout ${this.state.mobileNavOpen ? 'layout_nav-open' : ''}`}>
        <Head>
          <title>Matlogica company website</title>
          <link rel="icon" href="static/favicon.ico" type="image/x-icon"/>
          <link rel="icon" type="image/png" href="static/favicon-16x16.png" sizes="16x16"/>
          <link rel="icon" type="image/png" href="static/favicon-32x32.png" sizes="32x32"/>
          <link rel="stylesheet" href="https://cdn.linearicons.com/free/1.0.0/icon-font.min.css" />
          <link rel='stylesheet' href='https://fonts.googleapis.com/css?family=Poppins:100,200,400,300,500,600,700'/>
          <meta name="viewport" content="width=device-width, initial-scale=1"/>
          <link href="https://assets.calendly.com/assets/external/widget.css" rel="stylesheet"/>
          <script src="https://assets.calendly.com/assets/external/widget.js" type="text/javascript"/>
          </Head>
        <Header
          onToggle={this.onMobileNavToggle}
        />
        <main>
          {this.props.children}
        </main>
        <Footer/>
      </div>
    )
  }
};
